/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services/schema-service';
import { BotDetectionMatchConfigItem } from 'ajs/modules/match/factories';

import { BotClassificationTypes } from 'generated-types';

import * as l10n from './bot-management-match-readonly.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component to show readonly information for bot-managent-match.
 * @author Umesh Chovatiya
 */
@Component({
    selector: 'bot-management-match-readonly',
    templateUrl: './bot-management-match-readonly.component.html',
})
export class BotManagementMatchReadonlyComponent {
    /**
     * BotDetectionMatchConfigItem ObjectTypeItem Instance.
     */
    @Input()
    public editable: BotDetectionMatchConfigItem;

    public readonly l10nKeys = l10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly schemaService: SchemaService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Returns text for list of classification. if classification is user-defined-bot then
     * return classification with user_defined_type.
     */
    public get classificationTexts(): string[] {
        return this.editable.config.classifications.data.config.map(classificationText => {
            const classificationEnumText: string = classificationText.data.config.type;

            const classfication = this.schemaService.getEnumValueLabel(
                'BotClassificationTypes',
                classificationEnumText,
            );

            if (classificationEnumText === BotClassificationTypes.USER_DEFINED_BOT) {
                return `${classfication} ( ${classificationText.data.config.user_defined_type} )`;
            }

            return classfication;
        });
    }

    public trackByIndex(index: number): number {
        return index;
    }
}
